import { Input, InputProps } from 'antd';
import styled from 'styled-components';

export const InputContainer = styled(Input)<InputProps>`
  width: 100%;
`;
